import { NgModule } from '@angular/core';
import { FlatinfoModule } from './flatinfo.module';
import { FlatinfoEmbededComponent } from './component/flatinfo-embeded.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StockBadgeModule } from '../@stock-badge';
import { AngularYandexMapsModule, YaConfig } from 'angular8-yandex-maps';
import { CommonModule } from '@angular/common';
import {Fz152Component} from '../../shared/fz152/fz152/fz152.component';


const mapConfig: YaConfig = {
  apikey: 'f37ee804-d624-4207-a516-5305a1532809',
  lang: 'ru_RU',
};


@NgModule({
    imports: [
        CommonModule,
        FlatinfoModule,
        FormsModule,
        ReactiveFormsModule,
        StockBadgeModule,
        AngularYandexMapsModule.forRoot(mapConfig),
        Fz152Component,
    ],
  declarations: [
    FlatinfoEmbededComponent,
  ],
  exports: [
    FlatinfoEmbededComponent,
  ]
})
export class FlatinfoEmbededModule {

}
